import { MarkdownPage } from "../components/MarkdownPage";
import { getContentBySlug, markdownToHtml } from "../utils/markdown";

type Props = {
  meta: {
    title: string;
  };
  content: string;
};

export default function PrivacyPolicy(props: Props) {
  return <MarkdownPage {...props} />;
}

export async function getStaticProps() {
  const { content: rawContent, ...meta } = getContentBySlug("privacy-policy", [
    "title",
    "content",
  ]);
  const content = await markdownToHtml(rawContent || "");

  return {
    props: {
      meta,
      content,
    },
  };
}
